import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50">
      <div className="container mx-auto px-6 max-w-5xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8">Hakkımızda</h1>
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100">
            <h2 className="text-2xl font-semibold text-slate-800 mb-6">S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi</h2>
            <div className="prose prose-lg text-slate-600 max-w-none space-y-6">
              <p>
                2023 yılında kurulan S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi, bölgede iş dünyasının ihtiyaçlarına yönelik modern ve kapsamlı üretim-ticaret alanları oluşturmayı hedeflemiştir.
              </p>
              <p>
                Kooperatifimiz Silivri’de yer alan geniş bir arazi üzerinde proje geliştirme süreçlerine başlamıştır. Amacımız, üyelerimize çağdaş, altyapısı güçlü ve geleceğin ticari standartlarına uygun çalışma ortamları sunmaktır.
              </p>
              <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="rounded-xl overflow-hidden aspect-video relative">
                  <img
                    src="/images/renders_hero/hero5.jpg"
                    alt="Industrial Facility"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden aspect-video relative">
                  <img
                    src="/images/renders/render1.jpg"
                    alt="Industrial Facility"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
